import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CrownIcon } from 'assets/icons';
import { UpsellModal } from 'components';
import { AnalyticsEventLocation } from 'services/analytics/entities';
import { StyledButton, StyledContainer, StyledTypography } from './styled';

const UpgradeMessage = () => {
  const { t } = useTranslation();

  const [isUpsellModalOpen, setIsUpsellModalOpen] = useState(false);
  const handleUpsellModalClose = () => setIsUpsellModalOpen(false);
  const handleUpsellModalOpen = () => setIsUpsellModalOpen(true);

  return (
    <StyledContainer>
      <CrownIcon />
      <StyledTypography>
        {t('distribution:artistName:multipleArtistName')}
      </StyledTypography>

      <StyledButton variant="plainText" onClick={handleUpsellModalOpen}>
        {t('distribution:artistName:upgradeToAnnual')}
      </StyledButton>

      <UpsellModal
        isOpen={isUpsellModalOpen}
        onClose={handleUpsellModalClose}
        location={AnalyticsEventLocation.NEW_RELEASE_MODAL}
      />
    </StyledContainer>
  );
};

export default UpgradeMessage;
